import React from "react";
import ScheduleHearing from "../cause-list/ScheduleHearing";

const ScheduleCaseHearing = () => {
  return <ScheduleHearing />;
};

export default ScheduleCaseHearing;

